<template>
  <div class="pageAnnouncement" :class="[`pageAnnouncement--${layout}`]" ref="info">
    <div class="pageAnnouncement__inner">
      <div class="pageAnnouncement__label">{{ infoText }}</div>
      <div class="pageAnnouncement__content">
        <slot />
      </div>
      <button v-if="!hideClose" @click="close" class="pageAnnouncement__close">
        <span class="icon-line-close" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageAnnouncement',
  props: {
    infoText: {
      type: String,
      default: 'INFORMACJA',
    },
    cookieName: {
      type: String,
      default: 'pageAnnouncement',
    },
    text: {
      type: String,
      default: '',
    },
    layout: {
      type: String,
      default: 'purple',
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (!this.$cookies.get(this.cookieName)) {
      this.open();
    }
  },
  methods: {
    open() {
      this.$refs.info.style.maxHeight = `${this.$refs.info.scrollHeight}px`;
    },
    close() {
      this.$cookies.set(this.cookieName, '1', {
        path: '/',
        maxAge: 60 * 60 * 8,
      });
      this.$refs.info.style.maxHeight = `0px`;
    },
  },
};
</script>

<style lang="scss">
.pageAnnouncement {
  $root: &;
  /*max-height: 0;*/
  overflow: hidden;
  transition: max-height $tr;

  &__inner {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem 7rem;
    text-align: center;
    font-size: 1.2rem;
    line-height: 1.5rem;

    @include rwd('tablet') {
      padding: 1rem 4rem 1rem 2rem;
    }
  }

  &__content {
    button,
    a {
      color: #83ceff;
      text-decoration: underline;
    }
  }

  &__label {
    background: $cWhite;
    font-size: 1.1rem;
    line-height: 1.4rem;
    color: $cMainDark;
    border-radius: 50px;
    font-weight: 700;
    margin-right: 1rem;
    padding: 0.5rem 2rem;

    @include rwd('tablet') {
      display: none;
    }
  }

  &__close {
    position: absolute;
    right: 2rem;
    top: 50%;
    transform: translateY(-50%);
    padding: 1rem;
    color: $cWhite;

    @include rwd('tablet') {
      right: 0;
    }
  }

  .msg {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  &--purple {
    background: $cMain;
    color: $cWhite;
  }

  &--gray {
    background-color: #4c4f58;
    color: $cWhite;
  }
}
</style>
